import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Location } from 'types/commons';
import {
  RecruitmentOverviewClosedHiresList,
  RecruitmentOverviewReportJobsList,
  RecruitmentOverviewReportStatistics,
  ReportsState
} from 'types/reports';

import { RequestStatus } from 'constants/enums';

import {
  fetchRecruitmentOverviewReportCities,
  fetchRecruitmentOverviewReportClosedHires,
  fetchRecruitmentOverviewReportJobs,
  fetchRecruitmentOverviewReportStatistics
} from './reportsThunks';

const initialState: ReportsState = {
  recruitmentOverviewCities: [],
  recruitmentOverviewStatistics: {},
  recruitmentOverviewJobs: [],
  recruitmentOverviewClosedHires: [],
  recruitmentOverviewStatisticsError: null,
  recruitmentOverviewJobsCount: 0,
  recruitmentOverviewClosedHiresRequestStatus: RequestStatus.Idle
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchRecruitmentOverviewReportStatistics.fulfilled,
        (state, action: PayloadAction<RecruitmentOverviewReportStatistics>) => {
          state.recruitmentOverviewStatistics = action.payload;
          state.recruitmentOverviewStatisticsError = null;
        }
      )
      .addCase(
        fetchRecruitmentOverviewReportStatistics.rejected,
        (state, action) => {
          state.recruitmentOverviewStatistics = {};
          state.recruitmentOverviewStatisticsError =
            action.error.message || null;
        }
      )

      .addCase(
        fetchRecruitmentOverviewReportJobs.fulfilled,
        (state, action: PayloadAction<RecruitmentOverviewReportJobsList>) => {
          state.recruitmentOverviewJobs = action.payload.content;
          state.recruitmentOverviewJobsCount = action.payload.totalElements;
        }
      )
      .addCase(fetchRecruitmentOverviewReportJobs.rejected, (state) => {
        state.recruitmentOverviewJobs = [];
        state.recruitmentOverviewJobsCount = 0;
      })

      .addCase(
        fetchRecruitmentOverviewReportCities.fulfilled,
        (state, action: PayloadAction<Location[]>) => {
          state.recruitmentOverviewCities = action.payload;
        }
      )
      .addCase(fetchRecruitmentOverviewReportCities.rejected, (state) => {
        state.recruitmentOverviewCities = [];
      })

      .addCase(
        fetchRecruitmentOverviewReportClosedHires.fulfilled,
        (state, action: PayloadAction<RecruitmentOverviewClosedHiresList>) => {
          state.recruitmentOverviewClosedHires = action.payload.content;
          state.recruitmentOverviewClosedHiresRequestStatus =
            RequestStatus.Succeeded;
        }
      )
      .addCase(fetchRecruitmentOverviewReportClosedHires.pending, (state) => {
        state.recruitmentOverviewClosedHires = [];
        state.recruitmentOverviewClosedHiresRequestStatus =
          RequestStatus.Loading;
      })
      .addCase(fetchRecruitmentOverviewReportClosedHires.rejected, (state) => {
        state.recruitmentOverviewClosedHires = [];
        state.recruitmentOverviewClosedHiresRequestStatus =
          RequestStatus.Failed;
      });
  }
});

export default reportsSlice.reducer;
